export function adminView(node) {
    node.style.display = 'none';
    if (window.uData && window.uData.is_admin) {
        node.style.display = 'block';
    }
}
